import useLenis from "../hooks/useLenis";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TransitionStatement from "../components/TransitionStatement";
import BrandPillars from "../components/BrandPillars";
import WhyWeExist from "../components/WhyWeExist";
import WhoWeServe from "../components/WhoWeServe";
import PreviewCollective from "../components/PreviewCollective";
import FoundingMembers from "../components/FoundingMembers";
import KickOff from "../components/KickOff";
import Footer from "../components/Footer";

export default function Home() {
  useLenis();

  return (
    <div data-testid="home-page" className="relative bg-[#0B0B0B]">
      <Navbar />
      <main>
        <Hero />
        <TransitionStatement />
        <BrandPillars />
        <WhyWeExist />
        <WhoWeServe />
        <PreviewCollective />
        <FoundingMembers />
        <KickOff />
      </main>
      <Footer />
    </div>
  );
}
